import React, { FC } from 'react'
import clsx from 'clsx'

import { StandardProps } from '../../types/common'
import { CloseIcon } from '../Icons'

import styles from './Sidebar.module.scss'

interface SidebarProps extends StandardProps {
  /**
   * Function to list items
   */
  items?: React.ReactNode
  /**
   * is open or not
   */
  isOpen?: boolean
  /**
   * Brand
   */
  brand?: React.ReactElement
  /**
   * Function for closing the sidebar
   */
  onClose?: () => void
  /**
   * Size
   */
}

export const Sidebar: FC<SidebarProps> = ({
  children,
  className,
  style,
  items,
  isOpen = false,
  brand,
  onClose,
  testid = 'sidebar',
  ...props
}) => {
  return (
    <div
      className={clsx(
        styles['hds-sidebar'],
        { [styles.show]: isOpen },
        className
      )}
      style={style}
      onClick={onClose}
      data-testid={testid}
      {...props}
    >
      <div className={styles['hds-sidebar__head']}>
        <button className={styles['hds-sidebar__button_close']}>
          <CloseIcon className={styles.icon} />
        </button>
      </div>
      <div className={styles['hds-sidebar__body']}>
        <div className={styles['hds-sidebar__brand']}>{brand}</div>
        <div className={styles['hds-sidebar__inner']}>{items}</div>
      </div>
    </div>
  )
}
